// src/content-packs/tenant.ts
var TENANT_VARIANT_KEYS = [
  "help.cockpit:console.queue.body",
  "help.cockpit:sessionDetail.evidence.body",
  "help.cockpit:settingsRetention.storage.body",
  "help.cockpit:field.settingsGrants.reason.why",
  "help.cockpit:field.newSession.regime.label",
  "help.cockpit:field.newSession.customerType.label",
  "help.cockpit:field.newSession.customerType.why",
  "help.cockpit:tour.console.steps.queue.body",
  "help.cockpit:tour.sessionDetail.steps.identityEvidence.body",
  "help.cockpit:tour.sessionDetail.steps.identityEvidence.alt",
  "help.cockpit:tour.settingsRetention.steps.storage.body",
  "help.glossary:vcip.def",
  "help.glossary:vcip.ext",
  "help.glossary:geotag.ext",
  "help.glossary:aiGates.ext",
  "help.livesession:panel.decision.body",
  "help.livesession:panel.invariants.body",
  "help.livesession:field.consent.why",
  "help.livesession:field.copilot.why",
  "help.livesession:field.hardGates.why",
  "help.livesession:explainer.decision.n.copilotDesc",
  "help.livesession:manual.overview.body",
  "help.livesession:manual.decision.body",
  "help.livesession:playbook.dropped.s1"
];
var PLATFORM_PLANE_KEYS = [
  "help.cockpit:platformStorage.sinks.body",
  "help.cockpit:field.platformTenants.regime.label",
  "help.cockpit:field.platformTenants.managePurpose.label",
  "help.cockpit:field.platformTenants.managePurpose.why",
  "help.cockpit:tour.platformTenants.steps.manageAs.body",
  "help.cockpit:tour.platformStorage.steps.register.body"
];

// src/content/constants.ts
var LOCALES = ["en", "hi", "gu", "mr", "fr", "it", "es", "pt", "de", "ar"];
var AVAILABLE_LOCALES = ["en", "hi", "fr", "de", "es", "pt", "ar"];
var RTL_LOCALES = ["ar"];
var BASE_LOCALE = "en";
var HELP_REGIMES = ["RBI", "IFSCA", "TENANT"];

// src/content/regime.ts
var TENANT_NS = "help.tenant";
var TENANT_VARIANTS = new Set(TENANT_VARIANT_KEYS);
function normalizeHelpRegime(regime) {
  const r = regime?.trim().toUpperCase();
  if (!r) return null;
  if (r === "TENANT_POLICY") return "TENANT";
  return HELP_REGIMES.includes(r) ? r : null;
}
function tenantVariantKey(key) {
  const idx = key.indexOf(":");
  const ns = key.slice(0, idx).replace(/^help\./, "");
  return `${TENANT_NS}:${ns}.${key.slice(idx + 1)}`;
}
function regimeLocaleKey(key, regime) {
  return regime === "TENANT" && TENANT_VARIANTS.has(key) ? tenantVariantKey(key) : key;
}
function appliesToRegime(scoped, regime) {
  if (!scoped.regimes || scoped.regimes.length === 0) return true;
  return scoped.regimes.includes(regime ?? "RBI");
}
var REF_LISTS = [
  "seeAlso",
  "glossaryRefs",
  "relatedUseCases",
  "relatedWalkthroughs",
  "relatedExplainers",
  "relatedRefs",
  "relatedFeatures"
];
var REF_SINGLES = ["learnMoreRef", "relatedManual", "explainerRef"];
function scopeArtifactsToRegime(artifacts, regime) {
  const kept = artifacts.filter((a) => appliesToRegime(a, regime));
  const hidden = new Set(
    artifacts.filter((a) => !appliesToRegime(a, regime)).map((a) => a.helpKey)
  );
  let changed = kept.length !== artifacts.length;
  const out = kept.map((artifact) => {
    const next = scopeOne(artifact, regime, hidden);
    if (next !== artifact) changed = true;
    return next;
  });
  return changed ? out : artifacts;
}
function scopeOne(artifact, regime, hidden) {
  const record = artifact;
  let copy;
  const edit = () => {
    if (!copy) copy = { ...record };
    return copy;
  };
  for (const field of REF_LISTS) {
    const refs = record[field];
    if (Array.isArray(refs) && refs.some((k) => hidden.has(k))) {
      edit()[field] = refs.filter((k) => !hidden.has(k));
    }
  }
  for (const field of REF_SINGLES) {
    const ref = record[field];
    if (typeof ref === "string" && hidden.has(ref)) edit()[field] = void 0;
  }
  if (artifact.kind === "glossary" && artifact.regulatoryRefs) {
    const refs = artifact.regulatoryRefs.filter((r) => appliesToRegime(r, regime));
    if (refs.length !== artifact.regulatoryRefs.length) {
      edit().regulatoryRefs = refs.length > 0 ? refs : void 0;
    }
  }
  return copy ?? record;
}

export { AVAILABLE_LOCALES, BASE_LOCALE, HELP_REGIMES, LOCALES, PLATFORM_PLANE_KEYS, RTL_LOCALES, TENANT_NS, TENANT_VARIANT_KEYS, normalizeHelpRegime, regimeLocaleKey, scopeArtifactsToRegime, tenantVariantKey };
//# sourceMappingURL=chunk-AI4VYR6C.js.map
//# sourceMappingURL=chunk-AI4VYR6C.js.map